import { render, staticRenderFns } from "./PosVenda.vue?vue&type=template&id=a5a14fe6&"
import script from "./PosVenda.vue?vue&type=script&lang=js&"
export * from "./PosVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports